module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_20.bc39bb11.jpg";